import { render, staticRenderFns } from "./BuildPooledContacts.vue?vue&type=template&id=4beac675&scoped=true"
import script from "./BuildPooledContacts.vue?vue&type=script&lang=js"
export * from "./BuildPooledContacts.vue?vue&type=script&lang=js"
import style0 from "./BuildPooledContacts.vue?vue&type=style&index=0&id=4beac675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beac675",
  null
  
)

export default component.exports